module.exports = __webpack_public_path__ + "img/icon-concept.bc11c267.svg";